// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScanEffortLevelSchema } from '../inputTypeSchemas/ScanEffortLevelSchema'
import { AttackSurfaceLicenseSupportSchema } from '../inputTypeSchemas/AttackSurfaceLicenseSupportSchema'
import { LicenseTypeSchema } from '../inputTypeSchemas/LicenseTypeSchema'

/////////////////////////////////////////
// LICENSE SCHEMA
/////////////////////////////////////////

export const LicenseSchema = z.object({
  scanEffortOverride: ScanEffortLevelSchema.nullable(),
  webApplicationSupport: AttackSurfaceLicenseSupportSchema,
  externalNetworkSupport: AttackSurfaceLicenseSupportSchema,
  aiApplicationSupport: AttackSurfaceLicenseSupportSchema,
  internalNetworkSupport: AttackSurfaceLicenseSupportSchema,
  licenseType: LicenseTypeSchema.nullable(),
  id: z.string(),
  tenantId: z.string(),
  name: z.string(),
  maxWebApplications: z.number().int().nullable(),
  maxAiApplications: z.number().int().nullable(),
  maxExternalNetworks: z.number().int().nullable(),
  maxInternalNetworks: z.number().int().nullable(),
  maxExternalNetworkHosts: z.number().int().nullable(),
  maxInternalNetworkHosts: z.number().int().nullable(),
  maxTotalAssets: z.number().int().nullable(),
  codeGraphLimit: z.number().int().nullable(),
  signalGenerationLimit: z.number().int().nullable(),
  aiCapacityUnitsPurchased: z.number().nullable(),
  applicationsBaselineBudget: z.number().int().nullable(),
  networkAssetsBaselineBudget: z.number().int().nullable(),
  customerPriceMarkup: z.number().nullable(),
  enforceApplicationGenerationLimits: z.boolean().nullable(),
  notes: z.string().nullable(),
  expiresAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type License = z.infer<typeof LicenseSchema>

export default LicenseSchema;
